(() => {
'use strict';
jQuery.fn.visible = function() {
    return this.css('visibility', 'visible');
};
jQuery.fn.invisible = function() {
    return this.css('visibility', 'hidden');
};
jQuery.fn.visibilityToggle = function() {
    return this.css('visibility', function(i, visibility) {
        return visibility == 'visible' ? 'hidden' : 'visible';
    });
};
function $60823b96a77d6a07$var$select_from_anchor() {
    let element = window.location.hash.substring(1);
    if ('' != element && element.search('vector') >= 0) document.getElementById(element).click();
}
jQuery(document).ready(($)=>{
    // ADD DIGITS EVERY 3 NUMBERS INSTEAD OF LOCALSTRING 'en-US'
    $.fn.digits = function() {
        return this.each(function() {
            $(this).text($(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
        });
    };
    var elements = document.querySelector('.periodic-table-grid');
    var smallElement = document.querySelector('.periodic-element-small');
    var largeElement = document.querySelector('.periodic-element-large');
    var legend = document.querySelector('.periodic-table-legends');
    // If these elements are not found, exit the script
    if (!elements || !smallElement || !largeElement || !legend) return;
    // var largeDescription = document.querySelector('.periodic-table-info');
    // var pti_name = document.querySelector('.pti-name');
    // var pti_description = document.querySelector('.pti-description');
    // var pti_attacks = document.querySelector('.pti-attacks');
    // var pti_devices = document.querySelector('.pti-devices');
    // var pti_port = document.querySelector('.pti-port');
    // var pti_vis_svg = document.querySelector('.pti-vis-svg');
    var pel_new = largeElement.querySelector('.element--new');
    var pel_amp = largeElement.querySelector('.element--amp');
    var pel_abb = largeElement.querySelector('.element--abb');
    var pel_risk = largeElement.querySelector('.element--risk');
    var pel_name = largeElement.querySelector('.element--name');
    if (elements) $('.periodic-element-small').click(function(e) {
        if (e.target.className === 'periodic-element-small') //e.target.dataset
        // run on change https://stackoverflow.com/questions/37203585/detect-data-on-change
        {
            if (largeElement && legend && smallElement) {
                e.preventDefault();
                $('.periodic-element-small').removeClass('active');
                $(this).addClass('active');
                let data = e.target.dataset;
                //
                // largeDescription.dataset.name = data.name;
                // largeDescription.dataset.color = data.color;
                // largeDescription.dataset.attacks = data.attacks;
                // largeDescription.dataset.devices = data.devices;
                // largeDescription.dataset.description = data.description;
                // pti_name.innerHTML = data.name;
                // pti_description.innerHTML = data.description;
                // if (data.attacks != 'n/a') {
                //     if (data.attacks.search('~') != -1) {
                //         pti_attacks.innerHTML = '~' + parseInt(data.attacks.replace('~', ''));
                //     } else {
                //         pti_attacks.innerHTML = parseInt(data.attacks);
                //     }
                //     $('.pti-attacks').digits();
                // } else {
                //     pti_attacks.innerHTML = 'n/a';
                // }
                // if (data.devices != 'n/a') {
                //     if (data.devices.search('~') != -1) {
                //         pti_devices.innerHTML = '~' + parseInt(data.devices.replace('~', ''));
                //     } else {
                //         pti_devices.innerHTML = parseInt(data.devices);
                //     }
                //     $('.pti-devices').digits();
                // } else {
                //     pti_devices.innerHTML = 'n/a';
                // }
                // pti_port.innerHTML = data.port.length ? data.port : 'n/a';
                // pti_vis_svg.innerHTML = data.visSvg ? '<img src="' + data.visSvg + '" alt="Visualization of attacks over time." />' : '';
                largeElement.dataset.name = data.name;
                largeElement.dataset.abb = data.abb;
                largeElement.dataset.amp = data.amp;
                largeElement.dataset.risk = data.risk;
                largeElement.dataset.new = data.new;
                largeElement.dataset.color = data.color;
                legend.dataset.amp = data.amp;
                legend.dataset.risk = data.risk;
                legend.dataset.new = data.new;
                legend.dataset.color = data.color;
                if ('1' === data.new) pel_new.innerHTML = '&#9733;';
                else pel_new.innerHTML = '&nbsp;';
                pel_amp.innerHTML = data.amp;
                pel_abb.innerHTML = data.abb;
                pel_risk.innerHTML = data.risk;
                var risk = '';
                for(var i = 0; i < 5 - data.risk; i++)risk += "<span>&#9675;</span>";
                for(i = 0; i < data.risk; i++)risk += "<span>&#9679;</span>";
                pel_risk.innerHTML = risk;
                if (data.risk == 0) {
                    $(".periodic-element-large .element--risk").invisible();
                    $(".risk-legends").hide();
                } else {
                    $(".periodic-element-large .element--risk").visible();
                    $(".risk-legends").show();
                }
                pel_name.innerHTML = data.name;
            }
        }
    });
    if (elements) {
        $(".slideshow").slick({
            dots: false,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            initialSlide: 1,
            infinite: false,
            mobileFirst: true,
            prevArrow: $('.modal__previous'),
            nextArrow: $('.modal__next'),
            lazyLoad: 'ondemand',
            adaptiveHeight: true
        });
        $('.slideshow').on('afterChange', function(event, slick, currentSlide, nextSlide) {
            var csColor = $(slick.$slides.get(currentSlide)).attr("data-color");
            // scroll the modal__container to the top
            var sliderScroll = document.querySelector('.modal__container');
            // set the sliderScroll data-color attribute
            sliderScroll.setAttribute('data-color', csColor);
            sliderScroll.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
    function showSlideshow(e) {
        e.preventDefault();
        MicroModal.init();
        MicroModal.show('periodic-table-modal-1');
        $('.slideshow').slick('slickGoTo', $('.periodic-element-modal[data-abb="' + e.target.dataset.abb + '"]').index(), true);
        // GET THE CONTAINER ELEMENT
        const sliderScroll = document.querySelector('.slideshow-container .slick-list');
        // SCROLL TO SLICK SLIDER
        sliderScroll.scrollTo({
            top: 0,
            behavior: 'instant'
        });
        // wait for the image in the slider to load, then set the sliderScroll height
        // to match the intrinsic height of the slick-current slide
        setTimeout(function() {
            const currentSlide = document.querySelector('.slick-current');
            const currentSlideHeight = currentSlide.clientHeight;
            sliderScroll.style.height = currentSlideHeight + 'px';
        }, 1500);
    }
    matchMedia('(max-width: 1023px)').addEventListener('change', slideshowToggle);
    function slideshowToggle() {
        $(".periodic-table-grid li").on('click', showSlideshow);
    // if (matchMedia('(max-width: 1023px)').matches) {
    //     $(".periodic-table-grid li").on('click', showSlideshow);
    // } else {
    //     $(".periodic-table-grid li").off('click', showSlideshow);
    // }
    }
    if (elements) slideshowToggle();
    // DEFAULT VALUES
    const size = window.matchMedia("(max-width: 1023px)");
    function defaultValues() {
        var $selectedElement;
        if (size.matches) $selectedElement = $('.periodic-table-grid li:eq(17)').first();
        else $selectedElement = $('.periodic-table-grid li:eq(17)').first();
        // pti_name.innerHTML = $selectedElement.data("name");
        // pti_description.innerHTML = $selectedElement.data("description");
        // // see if attacks is NAN
        // if (isNaN(parseInt($selectedElement.data("attacks")))) {
        //     pti_attacks.innerHTML = parseInt($selectedElement.data("attacks"));
        // } else {
        //     pti_attacks.innerHTML = parseInt($selectedElement.data("attacks"));
        //     $('.pti-attacks').digits();
        // }
        // // see if devices is NAN
        // if (isNaN(parseInt($selectedElement.data("devices")))) {
        // 	pti_devices.innerHTML = $selectedElement.data("devices");
        // } else {
        // 	pti_devices.innerHTML = parseInt($selectedElement.data("devices"));
        // 	$('.pti-devices').digits();
        // }
        // var port_number = $selectedElement.data("port");
        // var vis_svg_file = $selectedElement.data("vis-svg");
        // if (vis_svg_file) {
        //     pti_vis_svg.innerHTML = '<img src="' + vis_svg_file + '" alt="Visualization of attacks over time." />';
        // }
        // pti_port.innerHTML = port_number.length ? port_number : 'n/a';
        pel_amp.innerHTML = $selectedElement.data("amp");
        pel_abb.innerHTML = $selectedElement.data("abb");
        pel_name.innerHTML = $selectedElement.data("name");
        // largeDescription.dataset.color = $selectedElement.data("color");
        // largeElement.dataset.color = $selectedElement.data("color");
        var riskValue = $selectedElement.data("risk");
        var newValue = $selectedElement.data("new");
        legend.dataset.amp = $selectedElement.data("amp");
        legend.dataset.risk = $selectedElement.data("risk");
        legend.dataset.new = $selectedElement.data("new");
        legend.dataset.color = $selectedElement.data("color");
        largeElement.dataset.color = $selectedElement.data("color");
        if ('1' === String(newValue)) {
            pel_new.innerHTML = '&#9733;';
            largeElement.dataset.new = $selectedElement.data("new");
        } else {
            pel_new.innerHTML = '&nbsp;';
            largeElement.dataset.new = '';
        }
        var defaultRisk = '';
        for(var i = 0; i < 5 - riskValue; i++)defaultRisk += "<span>&#9675;</span>";
        for(i = 0; i < riskValue; i++)defaultRisk += "<span>&#9679;</span>";
        if (riskValue == 0) {
            $(".periodic-element-large .element--risk").invisible();
            $(".risk-legends").hide();
        } else {
            $(".periodic-element-large .element--risk").visible();
            $(".risk-legends").show();
        }
        pel_risk.innerHTML = defaultRisk;
    }
    if (elements) {
        // REGISTER AND ADD FALLBACK FOR SAFARI
        defaultValues(size);
        if (size.addEventListener) size.addEventListener('change', defaultValues);
        else size.addListener(defaultValues);
    }
    if (elements) $60823b96a77d6a07$var$select_from_anchor();
    $(".attacks-number").digits();
    $(".devices-number").digits();
});

})();
//# sourceMappingURL=periodic-table.js.map
